// Texty patičky (siteFooter.js) — desktop i mobil sdílejí stejný DOM, jen ho
// CSS na mobilu přeskládá do akordeonu (footerAccordion.js).

export default {
  ig: {
    titleBefore: 'O nabídkách informujeme vždy ',
    titleAccent: 'jako první',
    titleAfter: ' na našem profilu',
    cta: 'Sledujte náš Instagram',
  },
  /** popisek nad pásem wordmarků značek */
  brandsLabel: 'Značky u nás:',
  colInfo: {
    eyebrow: 'Informace',
    title: 'Informace pro vás',
    contact: 'Kontakty',
    shipping: 'Doprava a platba',
    claims: 'Reklamace a vrácení zboží',
    withdrawal: 'Odstoupení ve lhůtě 14 dní',
    terms: 'Obchodní podmínky',
    privacy: 'Ochrana osobních údajů',
    ratings: 'Hodnocení obchodu',
  },
  colFirma: {
    eyebrow: 'Jipos',
    title: 'O firmě',
    store: 'Prodejna nářadí Bílina',
    b2b: 'Velkoobchod (B2B)',
    news: 'Aktuality',
    brands: 'Značky',
    contact: 'Kontakty',
  },
  colRadce: {
    eyebrow: 'Poradna',
    title: 'Nákupní rádce',
    tips: 'Rady a tipy',
    inspiration: 'Inspirace',
    service: 'Servis a náhradní díly',
    orderStatus: 'Stav objednávky',
    claimForm: 'Reklamační formulář',
    account: 'Váš zákaznický účet',
  },
  service: {
    eyebrow: 'Podpora',
    title: 'Zákaznický servis',
    lead: 'Poradíme vám',
    /** dovětek za `lead` — mobilní karta ho ukazuje, desktop schová CSS */
    leadMore: ' s výběrem',
    sub: 'Jsme tu pro vás',
  },
  newsletter: {
    eyebrow: 'Newsletter',
    title: 'Přihlaste se k odběru novinek',
    desc: 'Získejte tipy, akce a informace o novém nářadí – stačí zadat e-mail.',
    placeholder: 'Váš e-mail',
    submit: 'Odebírat',
    socialLabel: 'Sledujte nás na sociálních sítích:',
  },
  /** dopisek k nativnímu `#signature` (#47) — `nativeFrom` se hledá v nativním
   *  textu platformy a nahrazuje `nativeTo` */
  sign: {
    nativeFrom: 'Vytvořil',
    nativeTo: 'Běží na',
    sep: ' · ',
    label: 'Shoptet šablony na míru khoder.cz',
  },
  legal: {
    privacy: 'Zásady zpracování osobních údajů',
    terms: 'Obchodní podmínky',
    /** aria-label řádku právních odkazů */
    aria: 'Právní informace',
  },
};
